import { useCallback } from "react";
import type { Node } from "@xyflow/react";

const NODE_HEIGHT = 80;
const V_GAP = 100;

/**
 * Vertical auto-layout for activity steps.
 * Places nodes in a single column, top-to-bottom.
 */
export function useGraphLayout() {
  const getAutoLayout = useCallback(
    (nodes: Node[]): Node[] =>
      nodes.map((node, i) => ({
        ...node,
        position: {
          x: 0,
          y: i * (NODE_HEIGHT + V_GAP),
        },
      })),
    []
  );

  return { getAutoLayout };
}

/** Default position for a newly added node, below the lowest existing node. */
export function getNewNodePosition(existingNodes: Node[]): { x: number; y: number } {
  if (existingNodes.length === 0) return { x: 0, y: 0 };

  let maxY = 0;
  let sumX = 0;
  for (const n of existingNodes) {
    const bottom = n.position.y + (n.measured?.height ?? NODE_HEIGHT);
    if (bottom > maxY) maxY = bottom;
    sumX += n.position.x;
  }
  return { x: sumX / existingNodes.length, y: maxY + V_GAP };
}
